import {
  DistributionParamChange,
  DistributionParamChanges,
} from '../distribution/params';
import { GovParamChange, GovParamChanges } from '../gov/params';
import { MarketParamChange, MarketParamChanges } from '../market/params';
import { OracleParamChange, OracleParamChanges } from '../oracle/params';
import { SlashingParamChange, SlashingParamChanges } from '../slashing/params';
import { StakingParamChange, StakingParamChanges } from '../staking/params';
import { TreasuryParamChange, TreasuryParamChanges } from '../treasury/params';

export type ParamChange =
  | DistributionParamChange
  | GovParamChange
  | MarketParamChange
  | OracleParamChange
  | SlashingParamChange
  | StakingParamChange
  | TreasuryParamChange;

export type ParamChanges = DistributionParamChanges &
  GovParamChanges &
  MarketParamChanges &
  OracleParamChanges &
  SlashingParamChanges &
  StakingParamChanges &
  TreasuryParamChanges;

export namespace ParamChanges {
  export const ConversionTable = {
    ...DistributionParamChanges.ConversionTable,
    ...GovParamChanges.ConversionTable,
    ...MarketParamChanges.ConversionTable,
    ...OracleParamChanges.ConversionTable,
    ...SlashingParamChanges.ConversionTable,
    ...StakingParamChanges.ConversionTable,
    ...TreasuryParamChanges.ConversionTable,
  };

  export function fromData(data: ParamChange.Data[]): ParamChanges {
    const result: ParamChanges = {};
    for (const pc of data) {
      if (result[pc.subspace] === undefined) {
        result[pc.subspace] = {};
      }
      // @ts-ignore
      const converter = ParamChanges.ConversionTable[pc.subspace][pc.key][0];
      // @ts-ignore
      result[pc.subspace][pc.key] = converter(JSON.parse(pc.value));
    }
    return result;
  }

  export function toData(pc: ParamChanges): ParamChange.Data[] {
    const result: Array<ParamChange.Data> = [];
    for (const subspace of Object.keys(pc)) {
      // @ts-ignore
      for (const key of Object.keys(pc[subspace])) {
        // @ts-ignore
        const serializer = ParamChanges.ConversionTable[subspace][key][1];
        result.push({
          // @ts-ignore
          subspace,
          // @ts-ignore
          key,
          // @ts-ignore
          value: JSON.stringify(serializer(pc[subspace][key])),
        });
      }
    }
    return result;
  }
}

export namespace ParamChange {
  export type Type<S extends string, K extends string, T> = {
    subspace: S;
    key: K;
    value: T;
  };

  export type Data =
    | DistributionParamChange.Data
    | MarketParamChange.Data
    | OracleParamChange.Data
    | SlashingParamChange.Data
    | StakingParamChange.Data
    | TreasuryParamChange.Data
    | GovParamChange.Data;

  export namespace Data {
    export type Type<P extends ParamChange.Type<any, any, any>> = Pick<
      P,
      'subspace' | 'key'
    > & { value: string };
  }
}
